import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { Element } from '../../../element.model';
import { DataService } from '../../data.service';
import { AddCategoryDialogComponent } from '../add-category-dialog/add-category-dialog.component';
import { AddLagerDialogComponent } from '../add-lager-dialog/add-lager-dialog.component';
import { MatDividerModule } from '@angular/material/divider';
import { AddLagerortDialogComponent } from '../add-lagerort-dialog/add-lagerort-dialog.component';

@Component({
  selector: 'app-dialog-elemente-add',
  templateUrl: './dialog-elemente-add.component.html',
  styleUrls: ['./dialog-elemente-add.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatDividerModule
  ]
})
export class DialogElementeAddComponent {
  selectedCategory: string = '';
  selectedLager: string = '';
  selectedLagerort: string = '';
  lagerort: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogElementeAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { newElement: Element, categories: string[], lager: string[], lagerort: string[] },
    public dialog: MatDialog,
    private dataService: DataService
  ) { }

  onSaveClick(): void {
    this.data.newElement.kategorie = this.selectedCategory;
    this.data.newElement.lager = this.selectedLager;
    this.data.newElement.lagerort = this.selectedLagerort;

    this.dialogRef.close(this.data.newElement);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onLagerChanged(): void {
    if (!this.selectedLager) {
      this.lagerort = []; // Falls kein Lager ausgewählt ist, Liste leeren
      return;
    }

    this.dataService.getLagerorte(this.selectedLager).subscribe(lagerorte => {
      this.lagerort = lagerorte; // Aktualisiere die Dropdown-Optionen
      this.selectedLagerort = ''; // Setze die Auswahl zurück
    });
  }

  openAddLagerDialog(): void {
    const dialogRef = this.dialog.open(AddLagerDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.data.lager.push(result);
        this.selectedLager = result; // Setzen Sie das neue Lager als ausgewähltes Lager für das neue Element
      }
    });
  }

  openAddLagerortDialog(): void {
    const dialogRef = this.dialog.open(AddLagerortDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.lagerort.push(result);
        this.selectedLagerort = result; // Setzen Sie das neue Lager als ausgewähltes Lager für das neue Element
      }
    });
  }

  openAddCategoryDialog(): void {
    const dialogRef = this.dialog.open(AddCategoryDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.data.categories.push(result);
        this.selectedCategory = result;
      }
    });
  }
}
